import { useQuery } from '@tanstack/react-query'
import apiClientPlatform from '@/apiClientPlatform'
import type { PlatformOwnerOverviewResponse } from '@/types/platform'

export const platformOwnerOverviewKey = (ownerId: string) =>
  ['platformOwnerOverview', ownerId] as const

export const usePlatformOwnerOverviewQuery = (ownerId: string) => {
  return useQuery({
    enabled: Boolean(ownerId),
    queryKey: platformOwnerOverviewKey(ownerId),
    queryFn: async () => {
      const { data } =
        await apiClientPlatform.get<PlatformOwnerOverviewResponse>(
          `/platform/owners/${ownerId}/overview`
        )
      return data
    },
  })
}
